module.exports = __webpack_public_path__ + "static/media/SashaDiamondFotoVideo.b82c1e3d.PNG";